import { useState } from 'react';

const COLLAPSED_SECTIONS_KEY = 'faithinsight_sidebar_collapsed_sections';

// Collapsible nav-section headers — persisted per-browser so a section stays
// however the user last left it across reloads. Every section defaults to
// collapsed EXCEPT ones flagged `defaultExpanded: true` in
// sidebarNavigationItems.js (the section holding "Dashboard" — the landing
// page right after login, so it should already be open). On desktop widths every section starts
// expanded too; the narrow-screen drawer keeps them collapsed. Once the user explicitly toggles a section,
// their choice (true/false) is stored and wins over the default from then on.
const DESKTOP_MIN_WIDTH = 769; // the same 768px breakpoint the sidebar uses for its mobile drawer
const isDesktop = () => typeof window !== 'undefined' && window.innerWidth >= DESKTOP_MIN_WIDTH;

export default function useSidebarCollapsedSections() {
  const [collapsedSections, setCollapsedSections] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(COLLAPSED_SECTIONS_KEY)) || {};
    } catch (error) {
      return {};
    }
  });

  const isSectionCollapsed = (sectionName, defaultExpanded = false) => {
    const stored = collapsedSections[sectionName];
    return stored !== undefined ? stored : !(defaultExpanded || isDesktop());
  };

  const toggleSection = (sectionName, isCurrentlyCollapsed) => {
    setCollapsedSections((prev) => {
      const next = { ...prev, [sectionName]: !isCurrentlyCollapsed };
      try {
        localStorage.setItem(COLLAPSED_SECTIONS_KEY, JSON.stringify(next));
      } catch (error) {
        // localStorage unavailable — collapse state just won't persist
      }
      return next;
    });
  };

  return { isSectionCollapsed, toggleSection };
}
